module.exports = __webpack_public_path__ + "assets/img/10.aca8b6ec.jpg";